




































import infoRowsBlock from '@/components/Ui/ActiveInfoPage/Blocks/infoRows.vue'
import Vue from 'vue'
import Mailing from '@/models/mailing/mailing'
import WeirdMailing from '../weirdMailingAlert.vue'
import UiTag from '@/components/Ui/Tag/Tag.vue'
import {wrapLinksInTag, wrapNewLine, safeClear, coerce} from '@/lib/text'
export default Vue.extend({
  props: {
    scope: {} as () => {mailing: Mailing},
    options: {}
  },
  components: {
    infoRowsBlock,
    WeirdMailing,
    UiTag
  },
  methods: {
    async cancel (): Promise<void> {
      try {
        await this.$store.dispatch('mailing/cancel', this.scope.mailing.getId())
        await this.$store.dispatch('mailing/get', this.scope.mailing.getId())
        // @ts-ignore
        this.$message.success(this.$t('newsletters.canceled'))
      } catch (error) {
        // @ts-ignore
        this.$message.error(this.$t('newsletters.not_canceled'))
      }
    },
    async resend (): Promise<void> {
      try {
        await this.$store.dispatch('mailing/resend', this.scope.mailing.getId())
        await this.$store.dispatch('mailing/get', this.scope.mailing.getId())
        // @ts-ignore
        this.$message.success(this.$t('newsletters.canceled_queue'))
      } catch (error) {
        // @ts-ignore
        this.$message.error(this.$t('newsletters.not_canceled_retry'))
      }
    },
    async send_now (): Promise<void> {
      try {
        await this.$store.dispatch('mailing/send_now', this.scope.mailing.getId())
        await this.$store.dispatch('mailing/get', this.scope.mailing.getId())
        // @ts-ignore
        this.$message.success(this.$t('newsletters.canceled_queue'))
      } catch (error) {
        // @ts-ignore
        this.$message.error(this.$t('newsletters.not_canceled_retry'))
      }
    }
  },
  computed: {
    text (): string {
      const text = coerce(this.scope.mailing.getText(), [safeClear, wrapLinksInTag, wrapNewLine])
      return text
    }
  }
})
